import { MicrosoftIconColor } from "@/components/icons/microsoft-icon-color";
import { Button } from "@/components/ui/button";
import { PublicClientApplication } from "@azure/msal-browser";
import React from "react";

const MS_APPLICATION_ID = import.meta.env.VITE_MICROSOFT_APPLICATION_ID;

export const SignInWithMicrosoftButton = ({
  onSuccess,
  onError,
}: {
  onSuccess: (token: string) => void;
  onError: (message: string) => void;
}) => {
  const msalInstance = React.useRef<null | PublicClientApplication>(null);

  React.useEffect(() => {
    if (!msalInstance.current) {
      msalInstance.current = new PublicClientApplication({
        auth: {
          clientId: MS_APPLICATION_ID,
          authority: `https://login.microsoftonline.com/common`,
          redirectUri: window.location.origin + "/login",
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: false,
        },
      });
    }
  }, []);

  const handleMicrosoftLogin = async () => {
    if (!msalInstance.current) return;

    try {
      await msalInstance.current.initialize();
      const loginResponse = await msalInstance.current.loginPopup({
        scopes: ["openid", "profile", "email", "phone"],
      });

      if (loginResponse && loginResponse.idToken) {
        onSuccess(loginResponse.idToken);
      } else if (loginResponse && !loginResponse.idToken) {
        onError("Unable to sign in with Microsoft");
      }
    } catch (error) {
      onError("Unable to sign in with Microsoft");
    }
  };
  return (
    <Button
      name="oauthMicrosoft"
      id="oauthMicrosoft"
      type="button"
      className="relative"
      onClick={handleMicrosoftLogin}
    >
      <MicrosoftIconColor className="absolute left-2 top-1/2 size-4 -translate-y-1/2" />
      Sign in with Microsoft
    </Button>
  );
};
